import React from 'react';
import PropTypes from 'prop-types';

import './Checkbox.scss';

const CheckboxSimple = ({
  checked,
  disabled,
  name,
  onChange,
}) => (
  <div className="Checkbox">
    <input
      id={name}
      name={name}
      type="checkbox"
      className="Checkbox__Input"
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
    <div className="Checkbox__Stylized" />
  </div>
);

CheckboxSimple.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

CheckboxSimple.defaultProps = {
  checked: false,
  disabled: false,
};

CheckboxSimple.displayName = 'CheckboxSimple';
export default CheckboxSimple;
